import { PERSONA_PROFILE_FIXED_FIELDS, PERSONA_DATA_FIELD_PREFIX, isForbiddenPersonaDataTitle } from './personaWidgetTypes'
import { PERSONA_STATUS_LABELS } from '../personas/personaStatusLabels'
import formatUpdateDate from '../updates/formatUpdateDate'

// De regels die 'Traject en gegevens' toont: één per gekozen veld, in de
// gekozen volgorde, met label en leesbare waarde. Een gekozen veld zonder
// waarde blijft staan als leeg — weglaten zou 'niet ingevuld' en 'niet
// gekozen' laten samenvallen.
// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md (T9)
// AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading

/**
 * @typedef {object} PersonaProfileRow
 * @property {string} key - Sleutel uit `Settings.fields`
 * @property {string} label - Naam van het veld
 * @property {string} value - Leesbare waarde; '' als het veld leeg is
 * @property {boolean} isEmpty - Het veld is gekozen maar bij deze deelnemer niet ingevuld
 */

/** Opgeslagen als 'YYYY-MM-DD' (input type=date); een andere vorm blijft zoals hij is. */
const readableDate = (value) => formatUpdateDate(value) || value

/**
 * @param {string} key
 * @returns {string|null} Label, of null voor een onbekende of verboden sleutel
 */
const labelFor = (key) => {
    if (PERSONA_PROFILE_FIXED_FIELDS[key]) return PERSONA_PROFILE_FIXED_FIELDS[key].label
    if (key.startsWith(PERSONA_DATA_FIELD_PREFIX) && key.length > PERSONA_DATA_FIELD_PREFIX.length) {
        const title = key.slice(PERSONA_DATA_FIELD_PREFIX.length)
        // Een identificatienummer uit een oude keuze krijgt geen regel, ook niet als 'Niet ingevuld'.
        return isForbiddenPersonaDataTitle(title) ? null : title
    }
    return null
}

/**
 * @param {string} key
 * @param {*} raw
 * @returns {string}
 */
const displayValue = (key, raw) => {
    if (Array.isArray(raw)) return raw.join(', ')
    const text = String(raw)
    if (key === 'Status') return PERSONA_STATUS_LABELS[text] || text
    return readableDate(text)
}

/**
 * @param {Array<string>|undefined} fields - `Settings.fields` van de widget
 * @param {Object<string, *>} profile - Uit personaProfileFromDocs of van de server
 * @returns {Array<PersonaProfileRow>}
 */
const personaProfileRows = (fields, profile) => (Array.isArray(fields) ? fields : [])
    .filter((key) => typeof key === 'string' && labelFor(key) !== null)
    .map((key) => {
        const raw = profile ? profile[key] : undefined
        const isEmpty = raw === undefined || raw === null || raw === ''
        return { key, label: labelFor(key), value: isEmpty ? '' : displayValue(key, raw), isEmpty }
    })

export default personaProfileRows
